import { ICoSo } from "./../../../model/respone/category/ICoSo";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmCoSoActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as ICoSo[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as ICoSo | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as ICoSo,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};
export const eDmCoSoActionIds = generateActionTypeIds(
  eDmCoSoActionsObj,
  "CO_SO"
);
export type IDmCoSoActionTypes = IGenericActionType<
  typeof eDmCoSoActionsObj,
  "CO_SO"
>;
